import {
  ADD_PURCHASE_ORDER,
  SET_PURCHASE_ORDERS,
  UPDATE_PURCHASE_ORDER,
} from '../actionTypes';
import {IFarmInputPurchaseOrder} from 'constants/interfaces';

export type PurchaseOrderState = {
  lastUpdate: number;
  purchaseOrders: IFarmInputPurchaseOrder[];
};
const initialState: PurchaseOrderState = {lastUpdate: 0, purchaseOrders: []};

export default function (
  state = initialState,
  action: {type: string; payload: any},
) {
  switch (action.type) {
    case SET_PURCHASE_ORDERS: {
      const purchaseOrders: IFarmInputPurchaseOrder[] = action.payload || [];
      const stateUpdate: PurchaseOrderState = {
        lastUpdate: new Date().getTime(),
        purchaseOrders: purchaseOrders.map((purchaseOrder) => ({
          ...purchaseOrder,
        })),
      };
      return stateUpdate;
    }

    case UPDATE_PURCHASE_ORDER: {
      const purchaseOrderUpdate: IFarmInputPurchaseOrder = action.payload;
      if (!purchaseOrderUpdate) return state;

      const stateUpdate: PurchaseOrderState = {
        lastUpdate: state.lastUpdate,
        purchaseOrders: state.purchaseOrders.map((purchaseOrder) => {
          if (purchaseOrder.id === purchaseOrderUpdate.id)
            return {...purchaseOrderUpdate};
          return purchaseOrder;
        }),
      };
      return stateUpdate;
    }

    case ADD_PURCHASE_ORDER: {
      const purchaseOrder: IFarmInputPurchaseOrder = action.payload;
      if (!purchaseOrder) return state;
      const stateUpdate: PurchaseOrderState = {
        lastUpdate: state.lastUpdate,
        purchaseOrders: [purchaseOrder, ...state.purchaseOrders],
      };
      return stateUpdate;
    }

    default:
      return state;
  }
}
